window.addEventListener('DOMContentLoaded', () => {
  const $breadcrumb = document.querySelector(
    '.cmp-header__navigation .breadcrumb'
  );

  const menuHtml = $breadcrumb?.innerHTML;
  const $menu = document.createElement('div');
  $menu.innerHTML = menuHtml || '';
  $menu.classList.add('cmp-breadcrumb__menu');
  $breadcrumb?.appendChild($menu);

  $breadcrumb?.addEventListener('click', (e) => {
    const $parentMenu = (e.target as HTMLElement)?.closest(
      '.cmp-breadcrumb__menu'
    );
    if (!$parentMenu) {
      $menu.classList.toggle('cmp-breadcrumb__menu--visible');
    }
  });

  document.addEventListener('click', (e) => {
    const $parentMenu = (e.target as HTMLElement)?.closest(
      '.cmp-breadcrumb__menu'
    );
    const $parentButton = (e.target as HTMLElement)?.closest(
      '.cmp-header__navigation .breadcrumb'
    );
    if (!$parentMenu && !$parentButton) {
      $menu.classList.remove('cmp-breadcrumb__menu--visible');
    }
  });

  document.addEventListener('keyup', (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      $menu.classList.remove('cmp-breadcrumb__menu--visible');
    }
  });
});
